import types from '../types';
import createReducer from '../utils/createReducer';

import INITIAL_STATE from './initialState';

const initialState = INITIAL_STATE.entities;

const customMerge = (oldEntityValues, newEntityValues) => {
  const modifiedEntity = oldEntityValues;
  Object.keys(newEntityValues).forEach(entityId => {
      if (!modifiedEntity[entityId]) {
        modifiedEntity[entityId] = newEntityValues[entityId];
      } else {
        const entityObject = newEntityValues[entityId];
        for (const key in entityObject) {
          if (entityObject.hasOwnProperty(key)) {
            modifiedEntity[entityId][key] = entityObject[key];
          }
        }
      }
    });
  
  return modifiedEntity;
};

const reducerMap = {
  [types.app.SIGN_OUT_USER_SUCCESS]: (state, action) => {
    for (let key in initialState) {
      state[key] = initialState[key];
    }
  },
  [types.entities.UPDATE_ENTITIES]: (state, action) => {
    if (action.payload.rooms) {
      state.rooms.byId = action.payload.rooms.byId;
      state.rooms.allIds = action.payload.rooms.allIds;
    }
    if (action.payload.hotels) {
      state.hotels = action.payload.hotels;
    }
  },
};

export default createReducer(initialState, reducerMap);
